import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nf_lang") || "en");

  useEffect(() => {
    localStorage.setItem("nf_lang", lang);
    document.documentElement.classList.toggle("lang-deva", lang !== "en");
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.en;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useI18n() {
  return useContext(LanguageContext);
}
